import ImprovementClarificationTable from './ImprovementClarificationTable';

const ProductHydro = ({ refreshTrigger, exportName }) => (
  <ImprovementClarificationTable
    procurementTypeHeader='1'
    refreshTrigger={refreshTrigger}
    exportName={exportName}
  />
);

export default ProductHydro;
